import React, { useEffect, useState } from "react";
import { browserHistory } from "react-router";
import PropTypes from "prop-types";
import _ from "lodash";
import util from "../util/util";
import Pagination from "../pagination/pagination";
import ReportsSearchForm from "./reports-search-form";
import ReportsTable from "./reports-table";

export default function ReportList(props) {
  // search string;
  const [search, setSearch] = useState(``);
  // search field;
  const [field, setField] = useState(``);
  // search start date;
  const [start, setStart] = useState(null);
  // search end date;
  const [end, setEnd] = useState(null);
  // reports to display (will be populated by an Ajax call);
  const [reports, setReports] = useState([]);
  // page of reports results;
  const [page, setPage] = useState(1);
  // number of pages
  const [pageCount, setPageCount] = useState(0);
  // maintain search state;
  const [queryString, setQueryString] = useState(``);

  useEffect(() => {
    // using separate variables for the user search option, in order to avoid an
    // infinite loop, as these also have to be sent in the call to the backend
    const searchString = _.get(props, `location.query.search`, ``);
    const searchField = _.get(props, `location.query.field`, ``);
    const startDate = _.get(props, `location.query.start`, null);
    const endDate = _.get(props, `location.query.end`, null);
    const pageNumber = Number(_.get(props, `params.page`, 1));

    // and also saving the current/updated user options to be used later
    setSearch(searchString);
    setField(searchField);
    setStart(startDate);
    setEnd(endDate);
    setPage(pageNumber);
    setQueryString(_.get(props, `location.search`, ``));

    // get the report data to display, from the backend;
    const getReports = () => {
      util
        .getReports({
          search: searchString,
          field: searchField,
          start: startDate,
          end: endDate,
          page: pageNumber
        })
        .then(data => {
          setTimeout(() => {
            // saving the data from the backend
            setPageCount(Math.ceil(data.count / util.reportsResultsPerPage));
            setReports(data.results.length ? data.results : false);
          }, util.delayList);
        });
    };

    getReports();
  }, [props]);

  const searchSubmit = params => {
    setField(params.field);
    setSearch(params.search);
    setStart(params.start);
    setEnd(params.end);

    browserHistory.push(params.url);
  };

  return (
    <div className="reports">
      <h4 className="page__title">Reporting</h4>

      <ReportsSearchForm
        end={end}
        search={search}
        field={field}
        start={start}
        searchSubmit={params => searchSubmit(params)}
      />

      {reports && reports.length ? (
        <div>
          <ReportsTable
            currentPage={page}
            reports={reports}
            queryString={queryString}
          />

          <Pagination
            currentPage={page}
            pageCount={pageCount}
            path="reports"
            queryString={queryString}
          />
        </div>
      ) : null}
    </div>
  );
}

ReportList.propTypes = {
  location: PropTypes.object,
  params: PropTypes.object
};
